module.exports = __webpack_public_path__ + "media/images/riders/BERNARD_KERR-81f2d001b1598522f86e7bb35108acf9.png";